import React from "react";
import StartLeadForm from "./StartLeadForm";
import { CLOSE } from "../../data/startPageContent";
import useStartReveal from "./useStartReveal";
import StartShapes from "./StartShapes";
import "./StartSections.css";

/** Closing form (plan §4.9). */
export default function StartClose({ profession = null, utm = null }) {
  const ref = useStartReveal();
  return (
    <section id="start-close" className="st-section st-close" aria-labelledby="st-close-title">
      <div className="st-container st-reveal" ref={ref}>
        <div className="st-close-panel st-dark">
          <StartShapes prefix="st-close" kinds={["blob", "ring", "dot", "square"]} />
          <p className="st-overline st-center">{CLOSE.overline}</p>
          <h2 id="st-close-title" className="st-h2 st-center">{CLOSE.title}</h2>
          <p className="st-sub st-center st-close-sub">{CLOSE.sub}</p>
          <StartLeadForm variant="bottom" profession={profession} utm={utm} />
        </div>
      </div>
    </section>
  );
}
